import { useState } from "react";
import Toggle, { ToggleProps } from "components/Toggle";

type ToggleItemProps = ToggleProps & {
  value: string;
};

const ToggleGroup = ({
  value,
  onChange,
  className,
  items
}: {
  value: string[];
  onChange: (opts: string[]) => void;
  className: string;
  items: ToggleItemProps[];
}) => {
  const [selectedOptions, setSelectedOptions] = useState(value);

  const handleChange = (value: string, checked: boolean) => {
    const newSelectedOptions = checked ? [...selectedOptions, value] : selectedOptions.filter((item) => item !== value);
    setSelectedOptions(newSelectedOptions);
    onChange(newSelectedOptions);
  };

  return (
    <div className={className}>
      {items.map((item) => {
        return (
          <Toggle
            key={item.value}
            {...item}
            checked={selectedOptions.includes(item.value)}
            onChange={(checked: boolean) => {
              handleChange(item.value, checked);
            }}
          />
        );
      })}
    </div>
  );
};

export { ToggleGroup, Toggle };
